import "./style.css";
import { useState, useRef, useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";
import {
  addAttendance,
  addVisit,
  auth,
  db,
  getAllUsersOneTime,
  getSponserDetails,
} from "../../utils/firebase-config";
import { useNavigate, useLocation } from "react-router-dom";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import { styled } from "@mui/material/styles";
import {
  ADMIN,
  ATTENDANCE_COLLECTION,
  HELPDESK,
  IITD_TITLE,
  INDUSTRY,
  GOVERNMENT_OFFICER ,
  SCHOOL,
  PROFESSOR,
  COLLEGE,
  SPONSER,
  TEACHER,
  VISITOR,
  VISIT_COLLECTION,
  VOLUNTEER,
  getBackgroundColor,
  getFrontColor,
} from "../../utils/constants";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import { QrReader } from "react-qr-reader";
import { BarcodeScanner } from "../../utils/bar_code_scanner";
import BackButton from "../../components/back_button";
import {
  collection,
  query,
  where,
  onSnapshot,
  orderBy,
} from "firebase/firestore";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
    fontWeight: "bold",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));

export default function DetailPage() {
  const [qrData, setQrData] = useState(null);
  const navigation = useNavigate();
  const videoContainer = useRef(null);
  const location = useLocation();
  const [currentUser, setUser] = useState(null);
  const [cameraList, setCameraList] = useState([]);
  const [selectedCamera, setSelectedCamera] = useState(null);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [tracks, setTracks] = useState([]);
  const [attendant, setAttendant] = useState([]);
  const [sponser, setSponser] = useState();
  let userList = useRef([]);

  useEffect(() => {
    if (location.state === null) {
      navigation("/");
    } else {
      const user = location.state;
      if (user.type == VOLUNTEER || user.type == HELPDESK) {
        navigation("/");
        return;
      } else {
        if (user.type === VISITOR) {
          userList.current = [
            { key: "Name", value: user.name },
            { key: "Email", value: user.email },
            { key: "Phone", value: user.contact_number },
            { key: "Gender", value: user.gender },
            { key: "Address", value: user.address },
            { key: "Type", value: user.type },
          ];
        }
        if (user.type === SPONSER) {
          userList.current = [
            { key: "Name", value: user.name },
            { key: "Email", value: user.email },
            { key: "Phone", value: user.contact_number },
            { key: "Gender", value: user.gender },
            { key: "Address", value: user.address },
            { key: "Type", value: user.type },
            {
              key: "Verified",
              value: user.verified ? "Verified" : "Not-Verified",
            },
          ];
        }
        if (user.type === SCHOOL) {
          userList.current = [
            { key: "Name", value: user.name },
            { key: "School Name", value: user.school_name },
            { key: "Email", value: user.email },
            { key: "Phone", value: user.contact_number_head },
            { key: "Unique School Code", value: user.school_unique_code },
            { key: "Type", value: user.type },
          ];
        }
 if (user.type === COLLEGE) {
  userList.current = [
    { key: "Name", value: user.name },
    { key: "College Name", value: user.college_name },
    { key: "Email", value: user.email },
    { key: "Phone", value: user.contact_number_head },
    { key: "Unique College Code", value: user.college_unique_code },
    { key: "Type", value: user.type },
  ];
}
        if (user.type === INDUSTRY) {
          userList.current = [
            { key: "Name", value: user.name },
            { key: "Industry Name", value: user.industry_name },
            { key: "Email", value: user.email },
            { key: "Phone", value: user.contact_number },
            { key: "Gender", value: user.gender },
            { key: "Address", value: user.address },
            { key: "Type", value: user.type },
          ];
        }
        if (user.type === GOVERNMENT_OFFICER) {
  userList.current = [
    { key: "Organisation Name", value: user.organisation_name },
    { key: "Office Address", value: user.office_address },
    { key: "Rank", value: user.rank },
    { key: "Email", value: user.email },
    { key: "Phone", value: user.contact_number },
    { key: "Type", value: user.type },
  ];
}
        if (user.type === TEACHER) {
          userList.current = [
            { key: "Name", value: user.name },
            { key: "Email", value: user.email },
            { key: "Phone", value: user.contact_number },
            { key: "Gender", value: user.gender },
            { key: "School Code", value: user.school_unique_code },
            { key: "No. of students", value: user.number_of_students },
            { key: "Type", value: user.type },
          ];
        }
        if (user.type === PROFESSOR) {
  userList.current = [
    { key: "Name", value: user.name },
    { key: "Email", value: user.email },
    { key: "Phone", value: user.contact_number },
    { key: "Gender", value: user.gender },
    { key: "College Code", value: user.college_unique_code },
    { key: "No. of students", value: user.number_of_students },
    { key: "Type", value: user.type },
  ];
}
        if (user.type === ADMIN) {
          userList.current = [
            { key: "Name", value: user.name },
            { key: "Email", value: user.email },
            { key: "Type", value: user.type },
          ];
        }
        setUser(location.state);
      }
    }
  }, []);
  useEffect(() => {
    if (currentUser != null && currentUser.type === ADMIN) {
      const q = query(collection(db, ATTENDANCE_COLLECTION));
      const unsubscribe = onSnapshot(q, (querySnapshot) => {
        const track = [];
        let myAttendance = [];
        querySnapshot.forEach((doc) => {
          track.push(doc.data());
        });

        track.forEach((element) => {
          Object.keys(element).forEach((mapKey) => {
            myAttendance.push({
              attendant_by: element[mapKey].attendant_by,
              email: element[mapKey].email,
              time: element[mapKey].time,
              date: mapKey,
            });
          });
        });
        myAttendance = myAttendance.sort((a, b) =>
          `${a.time}`.localeCompare(`${b.time}`)
        );
        setAttendant(myAttendance);
      });
      return unsubscribe;
    }
  }, [currentUser]);

  useEffect(() => {
    if (currentUser != null && currentUser.type === SPONSER) {
      getSponserDetails(currentUser.sponsor_id).then((data) => {
        if (data != null) {
          setSponser(data);
        }
      });
    }
  }, [currentUser]);

  useState(() => {
    handleScan();
  }, []);

  useEffect(() => {
    if (currentUser != null) {
      const q = query(
        collection(db, VISIT_COLLECTION),
        where("email", "==", currentUser.email),
        orderBy("time", "desc")
      );
      const unsubscribe = onSnapshot(q, (querySnapshot) => {
        const track = [];
        querySnapshot.forEach((doc) => {
          track.push(doc.data());
        });
        setTracks(track);
      });
      return unsubscribe;
    }
  }, [currentUser]);

  function getTypeWidget(value) {
    return (
      <div className="detail-tile">
        <div
          style={{
            width: "100%",
            display: "flex",
          }}
        >
          <p
            style={{
              border: `solid ${getFrontColor(value)} 1px`,
              borderRadius: "100px",
              padding: "4px 10px",
              textAlign: "left",
              color: `${getFrontColor(value)}`,
              backgroundColor: `${getBackgroundColor(value)}`,
            }}
          >
            {value}
          </p>
        </div>
      </div>
    );
  }

  function handleScan(data) {
    if (currentUser != null && data !== null) {
      try {
        const decodeData = JSON.parse(atob(data));
        if (decodeData.key === "1234") {
          console.log(decodeData);
          if (qrData !== data) {
            setQrData(decodeData);
          }
        }
      } catch (error) {
        console.log(error);
      }
    }
  }
  function handleError(err) {
    console.error(err);
  }
  async function markAttendace() {
    const docId = await addAttendance(currentUser.email, qrData);
    if (docId > 0) {
      setQrData(null);
      // setDialogOpen(false);
    }
  }
  async function markVisit() {
    const docId = await addVisit(currentUser.email, qrData);
    if (docId !== null) {
      setQrData(null);
      setDialogOpen(false);
    }
  }
  const videoCon = {
    video: {
      deviceId: {
        exact: selectedCamera,
      },
    },
  };
  useEffect(() => {
    async function getCameraList() {
      try {
        const devices = await navigator.mediaDevices.enumerateDevices();
        console.log(devices);
        const videoDevices = devices.filter(
          (device) => device.kind === "videoinput"
        );
        console.log(videoDevices);
        setCameraList(videoDevices);
        if (videoDevices.length > 0) {
          setSelectedCamera(videoDevices[0].deviceId);
        }
      } catch (error) {
        console.error("Error accessing camera devices:", error);
      }
    }

    getCameraList();
  }, []);

  const handleCameraChange = (event) => {
    setSelectedCamera(event.target.value);
  };

  async function downloadCSV() {
    const allUsers = await getAllUsersOneTime();
    const dataMap = {};
    attendant.forEach((entry) => {
      const { date, email, attendant_by } = entry;

      if (!dataMap[date]) {
        dataMap[date] = {};
      }

      dataMap[date][email] = attendant_by;
    });
    const uniqueEmails = Array.from(
      new Set(attendant.map((entry) => entry.email))
    );
    const uniqueDates = Array.from(
      new Set(attendant.map((entry) => entry.date))
    );

    const csvHeader = ["email", ...uniqueDates].join(",");

    // Create the CSV rows
    const csvRows = uniqueEmails.map((email) => {
      const filterData = allUsers.filter((user) => user.email === email);

      const row = [
        `${filterData.length > 0 ? filterData[0].name : "-"} : ${email}`,
      ];
      uniqueDates.forEach((date) => {
        const attendant =
          dataMap[date][email] !== undefined
            ? `P - ${dataMap[date][email]}`
            : "A";
        row.push(attendant);
      });
      return row.join(",");
    });

    // Combine the header and rows to create the CSV string
    const csvString = [csvHeader, ...csvRows].join("\n");

    console.log(csvString);
    // console.log(JSON.stringify(attendant));
    // const csvData = objectToCsv(attendant);
    // console.log(csvData);
    var blob = new Blob([csvString], { type: "text/csv;charset=utf-8;" });
    if (navigator.msSaveBlob) {
      // IE 10+
      navigator.msSaveBlob(blob, `Attendance-${new Date()}.csv`);
    } else {
      var link = document.createElement("a");
      if (link.download !== undefined) {
        // feature detection
        // Browsers that support HTML5 download attribute
        var url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", `Attendance-${new Date()}.csv`);
        link.style.visibility = "hidden";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }
    }
  }
  const objectToCsv = function (data) {
    const csvRows = [];

    /* Get headers as every csv data format
        has header (head means column name)
        so objects key is nothing but column name
        for csv data using Object.key() function.
        We fetch key of object as column name for
        csv */
    const headers = Object.keys(data[0]);

    /* Using push() method we push fetched
           data into csvRows[] array */
    csvRows.push(headers.join(","));

    // Loop to get value of each objects key
    for (const row of data) {
      const values = headers.map((header) => {
        const val = row[header];
        return `"${val}"`;
      });

      // To add, separator between each value
      csvRows.push(values.join(","));
    }

    /* To add new line for each objects values
           and this return statement array csvRows
           to this function.*/
    return csvRows.join("\n");
  };

  return (
    <>
      <div className="form-div-detail">
        <div className="left-div-detail">
          <BackButton />
          <h1>{IITD_TITLE}</h1>
          {currentUser !== null && (
            <div className="detail-page">
              <TableContainer component={Paper}>
                <Table
                  sx={{ minWidth: 300 }}
                  size="small"
                  aria-label="customized table"
                >
                  <TableBody>
                    {userList.current.map((userData, index) => (
                      <StyledTableRow key={index}>
                        <StyledTableCell component="th" scope="row">
                          {userData.key}
                        </StyledTableCell>
                        <StyledTableCell align="right">
                          {userData.key === "Type"
                            ? getTypeWidget(userData.value)
                            : userData.value}
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <div style={{ width: "100%", textAlign: "center" }}>
                <button
                  className="submit-btn"
                  onClick={async () => {
                    const askCameraPermission =
                      await navigator.mediaDevices.getUserMedia({
                        video: true,
                      });
                    if (askCameraPermission.active === true) {
                      setDialogOpen(true);
                    }
                  }}
                >
                  {"Scan Visiting QR"}
                </button>
              </div>
            </div>
          )}
          {currentUser != null && currentUser.type === SPONSER && sponser && (
            <div className="detail-page" style={{ marginTop: "40px" }}>
              <TableContainer component={Paper}>
                <h6
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    fontWeight: "bold",
                  }}
                >
                  Sponser Details
                </h6>
                <Table
                  sx={{ minWidth: 300 }}
                  size="small"
                  aria-label="customized table"
                >
                  <TableBody>
                    <StyledTableRow>
                      <StyledTableCell component="th" scope="row">
                        Sponser Name
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        {sponser.sponsor_name}
                      </StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                      <StyledTableCell component="th" scope="row">
                        Amount
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        {sponser.sponsorship_amount}
                      </StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                      <StyledTableCell component="th" scope="row">
                        Payment Mode
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        {sponser.payment_mode}
                      </StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                      <StyledTableCell component="th" scope="row">
                        Payment Receipt
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        <a href={sponser.payment_receipt_url} target="_blank">
                          View Receipt
                        </a>
                      </StyledTableCell>
                    </StyledTableRow>
                    <StyledTableRow>
                      <StyledTableCell component="th" scope="row">
                        Payment Date
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        {sponser.payment_date}
                      </StyledTableCell>
                    </StyledTableRow>

                    <StyledTableRow>
                      <StyledTableCell component="th" scope="row">
                        Payment Verification
                      </StyledTableCell>
                      <StyledTableCell align="right">
                        {sponser.verified ? "Verified" : "Not-Verified"}
                      </StyledTableCell>
                    </StyledTableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          )}
        </div>
        {currentUser != null &&
          currentUser.type !== ADMIN &&
          currentUser.type !== VOLUNTEER &&
          currentUser.type !== HELPDESK && (
            <div className="right-div-detail">
              <div className="invisibleBox"></div>
              <h1>Visiting Tracks</h1>
              <TableContainer component={Paper}>
                <Table
                  sx={{ minWidth: 300 }}
                  size="small"
                  aria-label="customized table"
                >
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell align="center">S.No.</StyledTableCell>
                      <StyledTableCell align="center">Lab</StyledTableCell>
                      <StyledTableCell align="center">
                        Lab Presenter
                      </StyledTableCell>
                      <StyledTableCell align="center">Time</StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {tracks.map((row, index) => (
                      <StyledTableRow key={index}>
                        <StyledTableCell component="th" scope="row">
                          {`${index + 1}.`}
                        </StyledTableCell>
                        <StyledTableCell component="th" scope="row">
                          {row.place.lab_data.lab_name}
                        </StyledTableCell>
                        <StyledTableCell component="th" scope="row">
                          {row.place.name}
                        </StyledTableCell>
                        <StyledTableCell align="right">{`${row.time
                          .toDate()
                          .toLocaleTimeString()}`}</StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          )}
        <div className="right-div-detail">
          {currentUser !== null && currentUser.type == ADMIN && (
            <div className="right-div-detail">
              <div className="invisibleBox"></div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignContent: "center",
                  marginBottom: "10px",
                }}
              >
                <h1>Attendant by Me</h1>
                <button
                  style={{ margin: "0" }}
                  className="submit-btn"
                  onClick={async () => {
                    downloadCSV();
                  }}
                >
                  {"Download CSV"}
                </button>
              </div>
              <TableContainer component={Paper}>
                <Table
                  sx={{ minWidth: 300 }}
                  size="small"
                  aria-label="customized table"
                >
                  <TableHead>
                    <StyledTableRow>
                      <StyledTableCell align="center">S.No.</StyledTableCell>
                      <StyledTableCell align="center">Email</StyledTableCell>
                      <StyledTableCell align="center">
                        Attendant By
                      </StyledTableCell>
                      <StyledTableCell align="center">Date</StyledTableCell>
                      <StyledTableCell align="center">Time</StyledTableCell>
                    </StyledTableRow>
                  </TableHead>
                  <TableBody>
                    {attendant.map((row, index) => (
                      <StyledTableRow key={index}>
                        <StyledTableCell component="th" scope="row">
                          {`${index + 1}.`}
                        </StyledTableCell>
                        <StyledTableCell component="th" scope="row">
                          {row.email}
                        </StyledTableCell>
                        <StyledTableCell component="th" scope="row">
                          {row.attendant_by}
                        </StyledTableCell>
                        <StyledTableCell align="right">{`${row.time
                          .toDate()
                          .toLocaleDateString()}`}</StyledTableCell>
                        <StyledTableCell align="right">{`${row.time
                          .toDate()
                          .toLocaleTimeString()}`}</StyledTableCell>
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          )}
        </div>
      </div>
      <Dialog
        sx={{ "& .MuiDialog-paper": { width: "100%", maxHeight: 800 } }}
        maxWidth="md"
        open={dialogOpen}
        onClose={() => {
          setDialogOpen(false);
        }}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle>Scan QR Code</DialogTitle>
        <DialogContent dividers>
          <div
            style={{
              width: "100%",
              textAlign: "center",
            }}
          >
            <select value={selectedCamera} onChange={handleCameraChange}>
              {cameraList.map((camera) => (
                <option key={camera.deviceId} value={camera.deviceId}>
                  {camera.label || `Camera ${camera.deviceId}`}
                </option>
              ))}
            </select>
          </div>
          <div
            style={{
              width: "100%",
              textAlign: "center",
            }}
          >
            {/* <QrReader
                className="scanner"
                scanDelay={100}
                constraints={videoCon}
                onError={(data) => {
                  handleError(data);
                }}
                onResult={(data) => {
                  handleScan(data);
                }}
              /> */}
            <BarcodeScanner
              onResult={(data) => {
                handleScan(data);
              }}
              deviceId={videoCon.video.deviceId.exact}
              onError={(data) => {
                handleError(data);
              }}
            />

            {qrData !== null && (
              <div>
                {currentUser != null && currentUser.type !== ADMIN && (
                  <p>{`You have visited at : ${qrData.lab_data.lab_name}`}</p>
                )}
                <button
                  className="submit-btn"
                  onClick={() => {
                    if (currentUser.type === ADMIN) {
                      markAttendace();
                    } else {
                      markVisit();
                    }
                  }}
                >
                  {currentUser.type === ADMIN
                    ? "Mark Attendance"
                    : "Mark Visit"}
                </button>
              </div>
            )}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
